import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Bell, CheckCheck } from "lucide-react";

export default function NotificationsPage() {
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);

  const load = () => api.get("/notifications").then(r => { setItems(r.data.items); setUnread(r.data.unread); });
  useEffect(() => { load(); }, []);

  const markRead = async (id) => { await api.post(`/notifications/${id}/read`); load(); };
  const markAll = async () => { await api.post("/notifications/mark-all-read"); load(); };

  return (
    <div className="ma-page">
      <div className="ma-page-header">
        <h1 className="ma-h1" data-testid="notifications-title">Notifiche <span className="ma-badge">{unread}</span></h1>
        <button className="ma-btn-secondary" onClick={markAll} data-testid="btn-mark-all-read"><CheckCheck size={14}/> Segna tutte come lette</button>
      </div>
      <div className="ma-notif-list">
        {items.length === 0 && <div className="ma-empty">Nessuna notifica.</div>}
        {items.map(n => (
          <div key={n.id} className={`ma-notif ${n.is_read ? "read" : "unread"}`}>
            <div className="ma-notif-icon"><Bell size={16}/></div>
            <div className="ma-notif-body">
              <div className="ma-notif-title">{n.title}</div>
              {n.body && <div className="ma-notif-text">{n.body}</div>}
              <div className="ma-notif-time">{new Date(n.created_at).toLocaleString("it-IT")}</div>
            </div>
            {!n.is_read && <button className="ma-btn-link" onClick={()=>markRead(n.id)}>Segna letta</button>}
          </div>
        ))}
      </div>
    </div>
  );
}
